import { render } from "./MallPc.vue?vue&type=template&id=f6e9593e"
import script from "./MallPc.vue?vue&type=script&lang=js"
export * from "./MallPc.vue?vue&type=script&lang=js"

import exportComponent from "/home/hosting_users/shoplus/custom/survey-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__